import React, { FC } from 'react';

const SortDescIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.56762 11.2135C4.28822 11.6006 3.71178 11.6006 3.43238 11.2135L1.33671 8.30964C1.00261 7.84669 1.33341 7.2 1.90433 7.2L6.09567 7.2C6.66659 7.2 6.99739 7.84669 6.66329 8.30964L4.56762 11.2135Z"
        fill="black"
      />
      <path
        d="M4.56762 1.58656C4.28822 1.19942 3.71178 1.19942 3.43238 1.58657L1.33671 4.49041C1.00261 4.95336 1.33341 5.60005 1.90433 5.60005L6.09567 5.60005C6.66659 5.60005 6.99739 4.95336 6.66329 4.49041L4.56762 1.58656Z"
        fill="#CCCCCC"
      />
    </svg>
  );
};

export default SortDescIcon;
